import React, { useMemo } from 'react';
import DatePicker from 'react-datepicker';
import { ko } from 'date-fns/locale';

const SmsSendMobileLayout = ({
    TAB,
    allVisibleSelected,
    fetchUsers,
    form,
    getRowKey,
    handleMmsFileChange,
    handleSend,
    isSmsOverLimit,
    keyword,
    loadingUsers,
    mmsFiles,
    onChange,
    onOpenTemplates,
    selectedCount,
    selectedKeys,
    sending,
    setKeyword,
    setTab,
    sortedFilteredUsers,
    tab,
    tabLabel,
    toggleAllUsers,
    toggleUser,
    uploadingImages,
    users
}) => {
    const mobileSortedUsers = useMemo(() => {
        return [...sortedFilteredUsers].sort((leftUser, rightUser) => {
            const leftName = String(leftUser.stName || '');
            const rightName = String(rightUser.stName || '');
            const comparedName = leftName.localeCompare(rightName, 'ko', { sensitivity: 'base', numeric: true });

            if (comparedName !== 0) {
                return comparedName;
            }

            return String(leftUser.id || '').localeCompare(String(rightUser.id || ''), 'ko', { sensitivity: 'base', numeric: true });
        });
    }, [sortedFilteredUsers]);

    return (
        <>
            <div className={`sms-form-box is-mobile-layout ${tab === TAB.SMS ? 'is-sms' : 'is-mms'}`}>
                <div className="sms-send-type-tabs is-mobile-tabs">
                    <button type="button" className={`sms-type-tab ${tab === TAB.SMS ? 'active' : ''}`} onClick={() => setTab(TAB.SMS)}>SMS</button>
                    <button type="button" className={`mms-type-tab ${tab === TAB.MMS ? 'active' : ''}`} onClick={() => setTab(TAB.MMS)}>MMS</button>
                    <button type="button" className="template-type-tab" onClick={onOpenTemplates}>상용구</button>
                </div>
                <div className="sms-mobile-layout">
                    {tab === TAB.SMS ? (
                        <>
                            <div className="sms-mobile-composer sms-mobile-section">
                                <div className="sms-inline-schedule-row sms-mobile-datetime-row">
                                    <select
                                        className="sms-inline-mode"
                                        value={form.mode}
                                        onChange={(e) => onChange('mode', e.target.value)}
                                    >
                                        <option value={1}>즉시</option>
                                        <option value={0}>예약</option>
                                    </select>
                                    <DatePicker
                                        selected={form.sendDate}
                                        onChange={(date) => onChange('sendDate', date)}
                                        locale={ko}
                                        dateFormat="yyyy-MM-dd"
                                        className="sms-inline-date"
                                        calendarClassName="sms-datepicker-calendar"
                                        popperClassName="sms-datepicker-popper"
                                    />
                                    <input
                                        className="sms-inline-time"
                                        type="time"
                                        value={form.sendTime}
                                        onChange={(e) => onChange('sendTime', e.target.value)}
                                    />
                                </div>
                                <input
                                    className={`sms-inline-message ${isSmsOverLimit ? 'is-over-limit' : ''}`}
                                    value={form.message}
                                    onChange={(e) => onChange('message', e.target.value)}
                                    placeholder="전송메세지"
                                />
                                <button
                                    type="button"
                                    className="inline-send-btn sms-submit-btn"
                                    onClick={handleSend}
                                    disabled={sending || loadingUsers}
                                >
                                    {sending ? '전송 등록 중...' : '전송'}
                                </button>
                            </div>

                        </>
                    ) : (
                        <>
                            <div className="sms-mobile-composer sms-mobile-section">
                                <div className="sms-inline-schedule-row sms-mobile-datetime-row">
                                    <select className="sms-inline-mode" value={form.mode} onChange={(e) => onChange('mode', e.target.value)}>
                                        <option value={1}>즉시</option>
                                        <option value={0}>예약</option>
                                    </select>
                                    <DatePicker
                                        selected={form.sendDate}
                                        onChange={(date) => onChange('sendDate', date)}
                                        locale={ko}
                                        dateFormat="yyyy-MM-dd"
                                        className="sms-inline-date"
                                        calendarClassName="sms-datepicker-calendar"
                                        popperClassName="sms-datepicker-popper"
                                    />
                                    <input
                                        className="sms-inline-time"
                                        type="time"
                                        value={form.sendTime}
                                        onChange={(e) => onChange('sendTime', e.target.value)}
                                    />
                                </div>

                                <label className="label-inline mms-subject-row">
                                    <span>제목</span>
                                    <input value={form.subject} onChange={(e) => onChange('subject', e.target.value)} />
                                </label>

                                <div className="form-grid sms-mobile-form-grid">
                                    <label>
                                        <span>이미지 첨부 (최대 5개)</span>
                                        <input type="file" accept="image/*" multiple onChange={handleMmsFileChange} />
                                    </label>
                                </div>

                                {mmsFiles.length > 0 && (
                                    <div className="mms-file-list">
                                        {mmsFiles.map((file) => (
                                            <span key={file.name + file.size}>{file.name}</span>
                                        ))}
                                    </div>
                                )}

                                <label className="message-box no-label-field">
                                    <textarea
                                        rows={6}
                                        value={form.message}
                                        onChange={(e) => onChange('message', e.target.value)}
                                        placeholder="전송메세지"
                                    />
                                </label>

                                <button type="button" className="inline-send-btn mms-submit-btn" onClick={handleSend} disabled={sending || loadingUsers || uploadingImages}>
                                    {uploadingImages ? '이미지 업로드 중...' : sending ? '전송 등록 중...' : `${tabLabel} 전송`}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>

            <div className="sms-mobile-member-group">
                <div className="sms-mobile-toolbar">
                    <div className="sms-mobile-toolbar-group">
                        <input
                            className="member-search"
                            placeholder="회원 검색"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                        />
                        <button type="button" className="sms-mobile-refresh-btn" onClick={fetchUsers}>새로고침</button>
                    </div>
                </div>

                <div className="sms-mobile-summary">
                    <span>전체 {users.length}명</span>
                    <span>검색결과 {sortedFilteredUsers.length}명</span>
                    <span>선택 {selectedCount}명</span>
                </div>

                <div className="sms-mobile-member-list sms-mobile-section">
                    <div className="sms-mobile-section-header">
                        <h3 className="sms-mobile-section-title">회원 목록</h3>
                        <button type="button" className="sms-mobile-toggle-btn" onClick={toggleAllUsers}>
                            {allVisibleSelected ? '전체 해제' : '전체 선택'}
                        </button>
                    </div>

                    {loadingUsers ? (
                        <p className="sms-mobile-empty">회원 목록 조회 중...</p>
                    ) : mobileSortedUsers.length === 0 ? (
                        <p className="sms-mobile-empty">회원이 없습니다.</p>
                    ) : (
                        <div className="sms-mobile-user-list">
                            {mobileSortedUsers.map((user, index) => {
                                const userKey = getRowKey(user);
                                const isSelected = selectedKeys.has(userKey);

                                return (
                                    <button
                                        key={userKey}
                                        type="button"
                                        className={`sms-mobile-user-card ${isSelected ? 'is-selected' : ''}`}
                                        onClick={() => toggleUser(user)}
                                    >
                                        <div className="sms-mobile-user-card-header">
                                            <strong>{index + 1}. {user.stName || '-'} ({user.id || '-'})</strong>
                                            <span className={`sms-mobile-user-state ${isSelected ? 'is-selected' : ''}`}>
                                                {isSelected ? '선택됨' : '선택'}
                                            </span>
                                        </div>
                                    </button>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default SmsSendMobileLayout;
